export const localeRoot = "paywalls.community_members.billing_info_form";
